import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Toaster } from "react-hot-toast";
export function ToasterWrapper(_a) {
    var children = _a.children;
    return (_jsxs(_Fragment, { children: [children, _jsx(Toaster, {})] }));
}
